import { Component, ViewContainerRef } from '@angular/core';
import { SaleDocketStore } from '../sale-docket.store';
import { MatDialog } from '@angular/material/dialog';
import { EditSalesDocketSettingsComponent } from './edit-sales-docket-settings/edit-sales-docket-settings.component';
import { combineLatest, forkJoin, map } from 'rxjs';
import { KeyValuePairComponent } from '../../shared/general/key-value-pair/key-value-pair.component';
import { MatButton, MatAnchor } from '@angular/material/button';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-sale-docket-settings',
  templateUrl: './sale-docket-settings.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgxSkeletonLoaderModule,
    MatButton,
    KeyValuePairComponent,
    MatAnchor,
    AsyncPipe,
    TitleCasePipe
  ]
})
export class SaleDocketSettingsComponent {
  docket$ = this.saleDocketStore.docket$;
  docketLoading$ = this.saleDocketStore.docketLoading$;
  itemsLoading$ = this.saleDocketStore.itemsLoading$;
  canFinalizeDocket$ = this.saleDocketStore.canFinalize$;
  currencyDetails$ = combineLatest([
    this.saleDocketStore.currency$,
    this.saleDocketStore.currencyRate$
  ]).pipe(
    map(([currency, currencyRate]) => {
      if (currencyRate !== 1) {
        return `${currency} (${currencyRate})`;
      }
      return currency;
    })
  );

  constructor(
    private saleDocketStore: SaleDocketStore,
    private dialog: MatDialog,
    private viewRef: ViewContainerRef
  ) {}

  finalize() {
    this.saleDocketStore.finalize({});
  }

  openSettingsDialog() {
    this.dialog.open(EditSalesDocketSettingsComponent, {
      viewContainerRef: this.viewRef
    });
  }
}
